import script from "./base-date.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-date.vue?vue&type=script&setup=true&lang=ts"

import "./base-date.vue?vue&type=style&index=0&id=3099928e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3099928e"]])

export default __exports__